import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Input from '../../../../../common/form/Input'
import Select from '../../../../../common/form/Select'
import SubmitButton from '../../../../../common/buttons/SubmitButton'

import { addStudentToProgram } from '../../../../../../actions/waitlistActions'

import classes from './AddStudentForm.module.scss'

const AddStudentForm = ({ course, waitlistEntry, closeModal }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isLoading = useSelector(state => state.waitlist.isLoading)

  const packagesOptions = useMemo(
    () => course.availablePackages.map(package_ => ({ label: package_.name, value: package_.id })),
    [course]
  )

  const [coachMessage, setCoachMessage] = useState('')
  const [selectedPackage, setSelectedPackage] = useState(() => packagesOptions[0])

  const offlinePayment = course.paymentMethod?.cash

  const handleAddStudent = () => {
    dispatch(addStudentToProgram({ course, waitlistEntry, coachMessage, packageId: selectedPackage?.value }))
      .unwrap()
      .catch(() => toast.error(t('programs.manage.addStudentForm.errorAddingStudent'), { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => closeModal())
  }

  return (
    <>
      <div className='d-flex flex-column justify-content-center '>
        <p className='font-weight-bold mb-0'>{t('programs.manage.addStudentForm.sendMessage')}</p>
        <Input
          name='description'
          type='textarea'
          onChange={(e) => setCoachMessage(e.target.value)}
          placeholder={t('programs.common.messageToGolfers')}
          value={coachMessage}
          classNames={{
            inputContainer: classes.coachMessageInputContainer,
            inputContainerWrapper: 'mt-2',
          }}
        />
      </div>
      {offlinePayment && !!course.availablePackages.length && (
        <div className='mt-3'>
          <p className='font-weight-bold'>{t('programs.manage.addStudentForm.selectPackage')}</p>
          <Select
            options={packagesOptions}
            value={selectedPackage}
            onChange={option => setSelectedPackage(option)}
          />
        </div>
      )}
      <div>
        <div className='row py-3 justify-content-center align-items-center'>
          <div className='col-12'>
            <SubmitButton
              onClick={handleAddStudent}
              buttonMessage={t('programs.manage.addStudentForm.addToProgram')}
              buttonColor='orange-button'
              loading={isLoading}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </>
  )
}

AddStudentForm.propTypes = {
  course: PropTypes.shape({
    id: PropTypes.number,
    isCompleted: PropTypes.bool,
    paymentMethod: PropTypes.shape({
      cash: PropTypes.bool,
    }),
    availablePackages: PropTypes.array,
  }),
  waitlistEntry: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  closeModal: PropTypes.func,
}

export default AddStudentForm
